import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_verizon-logo",
  "use": "svg_verizon-logo-usage",
  "viewBox": "0 0 23 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 28\" id=\"svg_verizon-logo\"><path d=\"M18.752 0 8.233 22.564l-3.955-8.55H0L6.504 28h3.458L23 0h-4.248Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol